import PriceCheck from "@material-symbols/svg-500/rounded/price_check.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const PriceCheckIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: PriceCheck });
	return <Icon />;
};

export default memo(PriceCheckIcon);
